import Vue from "vue";
import Vuetify from "vuetify/lib";
import App from "./App.vue";
import store from "./store/index";
import router from './router';

Vue.config.productionTip = false;
Vue.use(Vuetify);
new Vue({
  vuetify: new Vuetify({
    theme: { dark: false }
  }),
  store,
  router,
  render: h => h(App)
}).$mount("#app");
